export const US_Product_List: any = [
    {
        productId: '7290965622857',
        variantId: '41636504305737',
        // Buy Now
        link_more: 'https://us.ecoflow.com/products/river-3-portable-power-station',
        // Amazon
        link_view: 'https://www.amazon.com/dp/B0DB1S36YP?maas=maas_adg_859899EB00F83EC5F048FAD373EDAAE2_afap_abs&ref_=aa_maas&tag=maas',
    },
    {
        productId: '7290968473673',
        variantId: '41636514136137',
        link_more: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.com/dp/B0DCCB657J?maas=maas_adg_C0A3AA9BAE8973E8449D0C6CE223F878_afap_abs&ref_=aa_maas&tag=maas',
    },
    {
        productId: '7290968473673',
        variantId: '41636515807305',
        link_more: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.com/dp/B0DPW7T85G?maas=maas_adg_5E285AC98099A0C21497F230ACED498B_afap_abs&ref_=aa_maas&tag=maas',
    },
];

export const US_Product_Options = [
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        amazonTimes: {
            startTime: '2024/12/10 16:00:00 GMT+8',
            endTime: '2024/12/15 16:00:00 GMT+8',
        },
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        amazonTimes: {
            startTime: '2024/12/10 16:00:00 GMT+8',
            endTime: '2024/12/15 16:00:00 GMT+8',
        },
        discountPrice: 0,
        originalPrice: 0,
    },
];

export const CA_Product_List: any = [
    {
        productId: '8335910928538',
        variantId: '45166394409114',
        link_more: 'https://ca.ecoflow.com/products/river-3-portable-power-station',
        link_view: 'https://www.amazon.ca/dp/B0DB4Y5VVT?maas=maas_adg_BD62BF62E23DAD18843AEEF45FE02ABE_afap_abs&ref_=aa_maas&tag=maas',
    },
    {
        productId: '8335918792858',
        variantId: '45166421999770',
        link_more: 'https://ca.ecoflow.com/products/river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.ca/dp/B0DFXX4D1D?maas=maas_adg_2DABF6F381CC91F0D654B7EA87A98D25_afap_abs&ref_=aa_maas&tag=maas',
    },
];

export const CA_Product_Options = [
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        hasTopRight: true,
        discountPrice: 0,
        originalPrice: 0,
        needBenefit: true,
        benefitTimes: {
            startTime: '2025/01/09 16:00:00 GMT+8',
            endTime: '2025/01/19 16:00:00 GMT+8',
        },
        amazonTimes: {
            startTime: '2025/01/09 16:00:00 GMT+8',
            endTime: '2025/01/13 16:00:00 GMT+8',
        },
    },
    {
        isDialog: true,
        label: 'Coming soon',
    },
];

export const AU_Product_List: any = [
    {
        productId: '8418809053382',
        variantId: '44377826328774',
        link_more: 'https://au.ecoflow.com/products/river-3-ups',
        link_view: 'https://www.amazon.ca/dp/B0DB4Y5VVT?maas=maas_adg_BD62BF62E23DAD18843AEEF45FE02ABE_afap_abs&ref_=aa_maas&tag=maas',
    },
    {
        productId: '8435565494470',
        variantId: '44377923027142',
        link_more: 'https://au.ecoflow.com/products/ecoflow-river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.ca/dp/B0DFXX4D1D?maas=maas_adg_2DABF6F381CC91F0D654B7EA87A98D25_afap_abs&ref_=aa_maas&tag=maas',
    },
    {
        productId: '8435565494470',
        variantId: '44377923125446',
        link_more: 'https://au.ecoflow.com/products/ecoflow-river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.ca/dp/B0DFXX4D1D?maas=maas_adg_2DABF6F381CC91F0D654B7EA87A98D25_afap_abs&ref_=aa_maas&tag=maas',
    },
    {
        productId: '8435565494470',
        variantId: '44377923158214',
        link_more: 'https://au.ecoflow.com/products/ecoflow-river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.ca/dp/B0DFXX4D1D?maas=maas_adg_2DABF6F381CC91F0D654B7EA87A98D25_afap_abs&ref_=aa_maas&tag=maas',
    },
];

export const AU_Product_Options = [
    {
        isShowBuyBtn: true,
        discountPrice: 0,
        originalPrice: 0,
        backupTime: '1.9 Hrs',
    },
    {
        isShowBuyBtn: false,
        // icon: 'https://websiteoss.ecoflow.com/upload/image/1737445394531/gift_icon.png',
        isDialog: true,
        label: 'Launches 17 Feb',
        backupTime: '2.2 Hrs',
    },
    {
        isShowBuyBtn: false,
        isDialog: true,
        label: 'Launches 17 Feb',
        backupTime: '4.5 Hrs',
    },
    {
        isShowBuyBtn: false,
        isDialog: true,
        label: 'Launches 17 Feb',
        backupTime: '6.7 Hrs',
    },
];
